import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateCallSummaryScoring = async ({ operatorSlackId, serviceType, startTimestamp, endTimestamp }: any) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      operatorSlackId,
      serviceType,
      startTimestamp,
      endTimestamp,
    },
    query: graphql(`
      query GenerateCallSummaryScoring($operatorSlackId: String!, $serviceType: String!, $startTimestamp: String!, $endTimestamp: String!) {
        generateCallSummaryScoring(
          operatorSlackId: $operatorSlackId
          serviceType: $serviceType
          startTimestamp: $startTimestamp
          endTimestamp: $endTimestamp
        ) {
          operator {
            id
            firstName
            lastName
            slackId
          }
          callSummaryRatings {
            callLogId
            score
          }
          unhelpfulCalls {
            id
            reason
          }
        }
      }
    `),
  });

  return response.data.generateCallSummaryScoring;
};
